export default __webpack_public_path__ + "static/media/DOM-AUG2026.0a9b7539.png";